import React, { useEffect, useState } from 'react'
import fetchHook from '../../../../hooks/fetchMSSQL-hook'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { Config } from './MachineTaskConstants'
import Pagination from '../../../../components/Pagination/Pagination'
import Filter from '../../../../components/Filter/Filter'

import {
  fromApiResponse,
  getTaskName,
  getStatusBadge,
  formatTaskValue
} from './Task'
import moment from 'moment'

export default function MachineTaskHistory() {
  const { fetchMssqlApi } = fetchHook()
  const [tasks, setTasks] = useState([])
  const { machineId } = useParams()

  const getTasks = () => {
    fetchMssqlApi(`machine-tasks/${machineId}`, { method: "GET" }, data => {
      const taskInstances = data.map(apiTask => fromApiResponse(apiTask))
      setTasks(taskInstances)
    }, error => {
      console.error(error)
    })
  }

  let defaultFilter = {
    showIndexes: false,
    page: 1,
    rowsPerPage: 25,
    rowsPerPageOptions: [10, 25, 50],
    visible: false,
    sortByColumns: true,
    sortBy: '3 | asc | text',
    activeTags: [],
    columns: [
      {
        id: 2,
        name: "Zadanie",
        sortable: true,
        searchable: true,
        type: 'text',
      },
      {
        id: 3,
        name: "Wartość",
        sortable: true,
        searchable: true,
        type: 'price',
      },
      {
        id: 4,
        name: "Start",
        sortable: true,
        searchable: true,
        type: 'date',
      },
      {
        id: 5,
        name: "Koniec",
        sortable: true,
        searchable: true,
        type: 'date',
      },
      {
        id: 6,
        name: "Status",
        sortable: true,
        searchable: true,
        type: 'date',
      },
      {
        id: 8,
        name: "Stworzone",
        sortable: true,
        searchable: true,
        type: 'date',
      },
      {
        id: 9,
        name: "Aktualizowane",
        sortable: true,
        searchable: true,
        type: 'date',
      }
    ],
  }


  const [filter, setFilter] = useState(() => {
    if (localStorage.getItem('machinetaskHistoryFilter')) {
      return JSON.parse(localStorage.getItem('machinetaskHistoryFilter'))
    } else return defaultFilter
  })

  const handleButtonClick = (e) => {
    e.preventDefault()
        fetchMssqlApi(`machine-tasks-cancel/${machineId}`, { method: 'PUT' }, () => getTasks());
  }

  const resetFilter = () => setFilter(defaultFilter)
  const toggleFilter = () => setFilter(prev => ({ ...prev, visible: !prev.visible }))

  const handleSwitchPage = pageNo => () => setFilter(prev => ({ ...prev, page: pageNo }))
  const resetPage = () => setFilter(prev => ({ ...prev, page: 1 }))

  // const filteredLogs = logs.filter(({ Messaeg }) => filterItems(searchedText, Name))

  const reportFilter = row =>
    filter.columns
      .filter(col => col.searchbar ? col.searchbar : col.selectbar)
      .every(col => {
        const x = String(row[Object.keys(row)[col.id - 1]])
          .toLowerCase()
          .includes(col.searchbar ? col.searchbar.toLowerCase() : col.selectbar.toLowerCase())
        return x
      })

  const sortRows = (a, b) => {
    const [id, order, type] = filter.sortBy.split(' | ')

    const col = Object.keys(tasks[0])[Number(id) - 1]

    if (a[col] === b[col]) return 0
    else if (a[col] === null) return 1
    else if (b[col] === null) return -1
    console.log(a, b);
    let valueA, valueB
    console.log(a[col], b[col]);
    if (type === 'text' || type === 'date') {

      // valueA = a[col]?.toLowerCase()
      // valueB = b[col]?.toLowerCase()
    }



    //   // Number().toLocaleString(undefined, {minimumFractionDigits: 2}) num => str '1 245 151,50'
    else return 0
    if (order === 'asc') return valueA < valueB ? -1 : 1
    else return valueA < valueB ? 1 : -1
  }

  useEffect(() => {
    getTasks()
  }, [])

  const cancelTask = (taskId) => {
    fetchMssqlApi(`machine-tasks/${taskId}`, { method: "PUT" }, () => getTasks())
  }

  const parseDatetime = (datetime) => {
    if (!datetime) return ''
    return moment.utc(datetime).local().format('YYYY-MM-DD HH:mm:ss')
  }

  const commandsMap = new Map(Config && Config.map(i => ([i.taskType, i.name])))

  const TaskRow = ({ task }) => {
    const isCancelable = task.status === 1;

    return (
      <tr>
        <td className="font-weight-bold text-dark">{getTaskName(task, commandsMap)}</td>
        <td><span className="badge badge-light border">{formatTaskValue(task)}</span></td>
        <td><small className="text-muted">{parseDatetime(task.startAt) || '-'}</small></td>
        <td><small className="text-muted">{parseDatetime(task.endAt) || '-'}</small></td>
        <td>{getStatusBadge(task.status)}</td>
        <td><small className="text-monospace text-truncate d-inline-block" style={{ maxWidth: '150px' }}>{task.response || '-'}</small></td>
        <td><small className="text-muted">{parseDatetime(task.createDateTime)}</small></td>
        <td><small className="text-muted">{parseDatetime(task.updateDateTime)}</small></td>
        <td className="text-right">
          <button
            className={`btn btn-sm ${isCancelable ? 'btn-danger' : 'btn-light text-muted border'}`}
            style={!isCancelable ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
            disabled={!isCancelable}
            onClick={() => cancelTask(task.machineTaskId)}
            title={isCancelable ? "Anuluj polecenie" : "Polecenie nie może zostać anulowane"}
          >
            Anuluj
          </button>
        </td>
      </tr>
    );
  };

  const filteredData = tasks.filter(reportFilter).sort(sortRows);
  const pagedData = filteredData.slice(
    (filter.page - 1) * filter.rowsPerPage,
    filter.page * filter.rowsPerPage
  );
  const isAllDisabled = tasks.length === 0 || tasks.every(task => task.status !== 1);

  return (
    <div className='card w-100 shadow-sm border-0 mb-4'>
      <div className='card-header bg-white py-3 d-flex justify-content-between align-items-center border-bottom'>
        <h5 className="m-0 font-weight-bold text-dark">
          Historia zleconych poleceń VMC
        </h5>
        <button
          className={`btn btn-sm ${isAllDisabled ? 'btn-light text-muted border' : 'btn-outline-danger'}`}
          style={isAllDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
          onClick={handleButtonClick}
          disabled={isAllDisabled}
        >
          Anuluj wszystkie aktywne
        </button>
      </div>

      <div className='card-body p-0'>
        <div className="p-3">
          <Pagination
            totalItems={filteredData.length}
            page={filter.page}
            rowsPerPage={filter.rowsPerPage}
            handleSwitchPage={handleSwitchPage}
            filterVisibility={filter.visible}
            toggleFilter={toggleFilter}
            resetFilter={resetFilter}
          />
          {filter.visible && (
            <Filter
              {...{
                filter,
                setFilter,
                columns: filter.columns,
                data: tasks,
                resetPage,
                resetFilter
              }}
            />
          )}
        </div>

        <div className="table-responsive">
          <table className='table table-hover align-middle mb-0'>
            <thead className="thead-light">
              <tr>
                <th>Zadanie</th>
                <th>Wartość</th>
                <th>Start</th>
                <th>Koniec</th>
                <th>Status</th>
                <th>Odpowiedź</th>
                <th>Stworzone</th>
                <th>Aktualizowane</th>
                <th className="text-right">Akcja</th>
              </tr>
            </thead>
            <tbody>
              {pagedData.length > 0 ? (
                pagedData.map(task => (
                  <TaskRow key={task.machineTaskId} task={task} />
                ))
              ) : (
                <tr>
                  <td colSpan={9} className="text-center py-4 text-muted">
                    Brak zarejestrowanych zleceń w historii.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
